import React from "react";
import OrganizationDetails from '../../components/BugBounty/OrganizationDetails';
import PersonalDetails from '../../components/BugBounty/PersonalDetails';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { Col, Button } from "react-bootstrap";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useHistory } from "react-router-dom"; // ✅ Import useHistory instead of useNavigate

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Detailspage() {
  const [value, setValue] = React.useState(0);
  const history = useHistory(); // ✅ Replacing useNavigate with useHistory

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }} className="bg-light">
      <div>
        <button onClick={() => history.goBack()} className="btn btn-secondary">
          Go Back
        </button>
      </div>

      <Box className="d-flex justify-content-center">
        <Tabs value={value} onChange={handleChange} className="justify-content-center">
          <Tab label={
            <Col className="text-center position-relative d-flex flex-column align-items-center">
              <Button className="d-flex align-items-center justify-content-center bg-primary rounded-circle mb-2" style={{ width: "50px", height: "50px" }}>
                <PeopleOutlineIcon sx={{ color: "white", fontSize: 24 }} />
              </Button>
              <p style={{ textTransform: 'none' }}>Personal Details</p>
            </Col>
          } {...a11yProps(0)} />

          <Tab label={
            <Col className="text-center position-relative d-flex flex-column align-items-center">
              <Button className="d-flex align-items-center justify-content-center bg-primary rounded-circle mb-2" style={{ width: "50px", height: "50px" }}>
                <WorkOutlineIcon sx={{ color: "white", fontSize: 24 }} />
              </Button>
              <p style={{ textTransform: 'none' }}>Organization Details</p>
            </Col>
          } {...a11yProps(1)} />
        </Tabs>
        
      </Box>

      <CustomTabPanel value={value} index={0}>
        <PersonalDetails />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <OrganizationDetails />
      </CustomTabPanel>
    </Box>
  );
}
